import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { typeface, get_color, respond, size_fixed_w } from '../assets/styles/index';
import qrCode from '../assets/images/home-daasc-qr.svg';
import appIcon from '../assets/images/image_app_icon@2x.png';
import close from '../assets/images/icn_stroke_close_20x20.svg';
import modal_close from '../assets/images/icn_stroke_close_grey02.svg';
import modal_close_green from '../assets/images/icn_stroke_close_hase_green.svg';
import { useEffect, useRef, useState } from 'react';
import useResponse from '../assets/hook/useResponse';
import { view } from '../utils/url';

const Modal = styled('div') <{ isActive?: boolean }>`
  font-family: Arial, Verdana, Helvetica, sans-serif, 'Microsoft JhengHei', '微軟正黑體' !important;
  display: ${props => props.isActive ? 'block' : 'none'};
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.55);
  .modal-content {
    box-sizing: border-box;
    background-color: #fefefe;
    margin: 0 auto;
    padding: 40px 30px 20px;
    width: 95%;
    max-width: 480px;
    color: #333;
    line-height: 130%;
    max-height: calc(100% - 150px);
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    border-radius: 6px;
    ${respond(['s'], `
      padding: 20px 30px 20px;
    `)}
    a {
      text-decoration: none;
      cursor: pointer;
    }
    .close {
      z-index: 999;
      display: block;
      height: 40px;
      max-height: 40px;
      min-height: 40px;
      max-width: 40px;
      min-width: 40px;
      width: 40px;
      bottom: auto;
      left: auto;
      position: absolute;
      right: 16px;
      top: 16px;
      background-image: url(${modal_close});
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      opacity: 1;
      &:hover {
        background-image: url(${modal_close_green});
        color: #000;
        text-decoration: none;
        cursor: pointer;
      }
      &:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }

  .modal-content {
    top: 30%;

    .warn-heading {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding-top: 15px;
      padding-bottom: 20px;
    }

    .warn-desc {
      font-size: 15px;
      text-align: left;
      margin-top: 10px;
      line-height: 24px;
    }

    .warn-btn {
      text-align: right;
      padding-top: 40px;

      .cancel-btn {
        border: 1px solid #005126;
        color: #005126;
        padding: 10px 40px;
        margin-right: 8px;
        border-radius: 3px;
      }

      .con-btn {
        background-color: #005126;
        color: #fff;
        padding: 10px 40px;
        border-radius: 3px;
      }

      .con-btn:hover,
      .cancel-btn:hover {
        text-decoration: underline;
      }
    }
  }
`;

const FooterBox = styled('div')`
  padding: 16px 24px;
  display: flex;
  justify-content: center;
  ${respond(['m'], `
    padding: 16px 18px;
  `)}
  ${respond(['s'], `
    padding: 16px 12px;
    flex-direction: column;
  `)}
`;

const FooterContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${respond(['t'], `
    ${size_fixed_w('972px')}
    padding: 0 26px;
  `)}

  ${respond(['s'], `
    flex-direction: column;
  `)}
`;

const FooterItem = styled('div')`
  display: flex;
  align-self: flex-start;
  ${respond(['s'], `
    flex-direction: column;
    align-self: initial;
  `)}
`;

const Message = styled('div')`
  ${typeface('body9')}
  .bold {
    font-weight: 600;
  }
  .disclaimer {
    padding-top: 4px;
  }
  a {
    ${typeface('body8')}
    color: ${get_color('grey01')};
    ${respond(['s'], `
      display: block;
    `)}
  }
`;

const Signature = styled('a')`
  ${typeface('body9')}
  display: flex;
  align-self: flex-end;
  color: ${get_color('grey02')};
  text-decoration: none;
  ${respond(['s'], `
    margin-top: 8px;
  `)}
`;

const FooterNote = styled('div')`
  background-color: ${get_color('grey09')};
  width: 100%;
  .note-container {
    padding: 32px 26px;
    margin: 0 auto;
    ${respond(['t'], `
      ${size_fixed_w('972px')}
    `)}
    ${respond(['m'], `
      padding: 32px 18px;
    `)}
    ${respond(['s'], `
      padding: 32px 12px;
    `)}
    .note-item {
      ${typeface('body11')}
      color: ${get_color('grey02')};
      &:not(:first-child) {
        padding-top: 8px;
      }
    }
  }
`;

const FooterDownload = styled('div') <{ fixed: boolean, isActive: boolean }>`
  ${props => !props.isActive && `
    display: none;
  `}
  ${props => props.fixed && `
    position: fixed;
    bottom: 0;
  `}
  ${typeface('body2')}
  background-color: ${get_color('grey08')};
  width: 100%;
  ${respond(['s'], `
    ${typeface('body4')}
  `)}
  .download-container {
    padding: 12px 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    &.mobile {
      padding: 12px;
    }
    ${respond(['t'], `
      ${size_fixed_w('972px')}
    `)}
    ${respond(['m'], `
      padding: 12px 18px;
    `)}
    .download-link {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: ${get_color('grey01')};
    }
    .download-item {
      display: flex;
    }
  }
`;

const FooterDownloadLogo = styled('img')`
  width: 70px;
  height: 70px;
  padding-left: 12px;
  ${respond(['s'], `
    padding-left: 0;
    padding-right: 12px;
    &.qrCode{
      display: none;
    }
  `)}
`;

const FooterDownloadClose = styled('a')`
  align-self: flex-start;
  min-width: 20px;
  min-height: 20px;
  margin-left: 12px;
  background-image: url(${close});
  background-size: cover;
`;

const Footer = () => {
  const { t, i18n } = useTranslation();
  const boxRef = useRef<HTMLDivElement>(null);
  const stickyRef = useRef<HTMLDivElement>(null);
  const [fixed, setFixed] = useState(true);
  const breakpoint = useResponse();
  const [stickyActive, setStickyActive] = useState(true);
  const [modalActive, setModalActive] = useState(false);

  const getStoreUrl = () => {
    let url: string;
    if (navigator.userAgent.includes("Mac OS")) {
      url = "https://apps.apple.com/app/hang-seng-personal-banking/id1039256353";
    } else {
      url = "https://play.google.com/store/apps/details?id=com.hangseng.rbmobile&hl=en-HK";
    }
    return url;
  };

  const trackDownloadEvent = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const os = navigator.userAgent.includes("Mac OS") ? "DownloadIOS" : "DownloadAOS";
    window.TMS.trackEvent({
      event_value: "[" + i18n.language.toLowerCase() + "]_PNL_guide_DownloadMobileAppButton_[" + (i18n.language === "zh-HK" ? "TC" : i18n.language === "zh-CN" ? "SC" : "EN") + "]_2022Q1",
      event_content: "PNL_guide_2022Q1_" + (isMobile ? "desktop" : "mobile") + "_IF_" + os
    });
  }

  const handleCloseSticky = (e: React.MouseEvent) => {
    e.preventDefault();
    setStickyActive(false);
    if (boxRef.current) {
      boxRef.current.style.marginTop = "0";
    }
  }

  const handleCloseModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setModalActive(false);
  }

  const handleOpenModal = (e: React.MouseEvent) => {
    e.preventDefault();

    if(view === 'd2g') {
      setModalActive(true);
    }
  }

  useEffect(() => {
    const handleStickyfunc = () => {
      if (boxRef.current && window.pageYOffset + window.innerHeight >= boxRef.current.offsetTop) {
        setFixed(false);
        boxRef.current.style.marginTop = "0";
      } else {
        setFixed(true);
        if (boxRef.current && stickyRef.current) {
          boxRef.current.style.marginTop = stickyRef.current.offsetHeight + "px";
        }
      }
    };
    window.addEventListener('scroll', handleStickyfunc);
  }, []);

  return (
    <>
      <FooterNote>
        <div className="note-container">
          <div className="note-item">{t('footer_note1')}</div>
          <div className="note-item">{t('footer_note2')}</div>
        </div>
      </FooterNote>
      {view !== 'daasc' && <FooterDownload ref={stickyRef} fixed={fixed} isActive={stickyActive}>
        {breakpoint === 's' ? (
          <div className="download-container mobile">
            <a href="#" onClick={handleOpenModal} className="download-link">
              <div className="download-item">
                <FooterDownloadLogo src={appIcon} alt="" />
              </div>
              <div className="download-item">{t('download_mobile')}</div>
            </a>
            <FooterDownloadClose href="#" aria-label={t('close')} onClick={handleCloseSticky} />
          </div>
        ) : (
          <div className="download-container">
            <div className="download-item">{t('download')}</div>
            <div className="download-item">
              <FooterDownloadLogo src={appIcon} alt="" />
              {view === 'd2g' && <FooterDownloadLogo className="qrCode" src={qrCode} alt={t('qrCode')} />}
              <FooterDownloadClose href="#" aria-label={t('close')} onClick={handleCloseSticky} />
            </div>
          </div>
        )}
      </FooterDownload>}

      <FooterBox ref={boxRef}>
        <FooterContainer>
          <FooterItem>
            <Message>
              {view === 'd2g' ?
                (<a href={"https://www.hangseng.com/" + i18n.language.toLowerCase() + "/resources/important-message/"}>{t('notices')}</a>) :
                (<a>{t('notices')}</a>)
              }
              {view !== 'd2g' ?
                (<div className="bold">{t('forDetail')}</div>) : ''
              }
              <div className="bold">{t('limited')}</div>
              <div className="disclaimer">
                {t('region')}
                {view === 'p2g' || view === 'd2g'? (
                  <a href={"https://www.hangseng.com/cms/smartbanking/" + (i18n.language === 'en-HK' ? 'eng' : i18n.language === 'zh-HK' ? 'chi' : 'schi') + "/tnc/index.html"}>{t('disclaimer')}</a>
                ) : 
                <a href={"https://www.hangseng.com/cms/smartbanking/" + (i18n.language === 'en-HK' ? 'eng' : i18n.language === 'zh-HK' ? 'chi' : 'schi') + "/tnc/index.html?view=daasc"}>{t('disclaimer')}</a>
                }
              </div>
            </Message>
          </FooterItem>
          <FooterItem>
            {view === 'd2g' ?
              (<Signature href="https://www.hsbc.com/" target="_blank">
                {t('signature')}
              </Signature>) :
              (<Signature>{t('signature')}</Signature>)}
          </FooterItem>
        </FooterContainer>
      </FooterBox>
      <Modal isActive={modalActive} className="warn-modal">
        <div className="modal-content warn-content">
          <a href="#" className="close" onClick={handleCloseModal}></a>
          <div className="warn-heading">{t('modal.heading')}</div>
          <div className="warn-desc">{t('modal.desc')}</div>
          <div className="warn-btn">
            <a href="#" className="cancel-btn" onClick={handleCloseModal}>{t('modal.cancel')}</a>
            <a className="con-btn hover_link_white" href={getStoreUrl()} onClick={trackDownloadEvent} target="_blank">
              {t('modal.proceed')}
              <span className="click-img-white align-middle"></span>
            </a>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Footer;
